function focusElement(elemToFocus) {
  elemToFocus.focus();

  // https://caniuse.com/#feat=scrollintoview looks pretty good but just in case.
  if (elemToFocus.scrollIntoView) {
    elemToFocus.scrollIntoView();
  }

  // Just in case we ever implement SSR.
  if (window) {
    // HACK: Account for fixed header height in our design.
    // The header height changes based on breakpoint so let's calculate it dynamically.
    const nav = window.document.querySelector('nav');
    const navHeight = nav ? nav.offsetHeight + 50 : 0;
    window.scroll(0, window.scrollY - navHeight);
  }
}

function handleInvalidForm(form) {
  // We use form.querySelector to find the first invalid element for three reasons:
  // 1) It means the component author only has to get a single React DOM ref (to the form itself).
  // 2) It means the component author doesn't have to work out which validation error is for
  //    the "first invalid element" (i.e. first in DOM order) and we'll always focus the first invalid
  //    element (which is important for usability and accessibility).
  // 3) It means the component author is forced to set aria-invalid correctly, because it's what we use to
  //    set focus and scroll into view.
  if (form && form.querySelector) {
    // Focus the first invalid form element, or, if no
    // invalid form element, assume there is a global error message
    // at the top of the form and focus the form itself.
    const firstInvalidInput = form.querySelector(':invalid');

    focusElement(firstInvalidInput || form);
  }
}

export {
  handleInvalidForm,
  focusElement
};



// WEBPACK FOOTER //
// ./src/services/validation.js